class MaintenanceExtensionOption {
	constructor(option) {
		this.newExpiration = option.newExpiration;
		this.id = option.extension.id,
		this.name = option.extension.name,
		this.category = option.extension.category,
		this.durationInMonths = option.extension.durationInMonths,
		this.amount = option.extension.amount,
		this.quantity = option.quantity;
		this.totalPrice = option.totalPrice;
		this.extensionLength = this.readableOption(option);
		this.isSelfService = true;
	}

	readableOption(option) {
		const extensionYearType = parseInt(option.extension.name[0]);
		if (Number.isNaN(extensionYearType)) {
			return;
		}
		const quantity = option.quantity;

		return `${quantity * extensionYearType} year`;
	}

}

export { MaintenanceExtensionOption };



// WEBPACK FOOTER //
// ./src/store/models/maintenance-option.js